import { useEffect, useState, useRef } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import path from 'path'
import fs from 'fs/promises' // or 'fs' if using callbacks
import {
  useWindowSize,
  Footer,
  TryEdworking,
  Header,
  EdworkingPromotion,
  SimilarArticles,
  Offer,
  asPathMap,
  TopBanner,
} from '../../js/components'

import {
  OrganizationSchema,
  WebPageSchema,
  BreadcrumbListSchema,
  FAQSchema,
} from '../../js/schemas'

import Image from 'next/image'
import ResultsChart from '../../js/chart'

export async function getStaticPaths() {
  return {
    paths: [
      { locale: 'en', params: { test: 'management-aptitude-test' } },
      { locale: 'it', params: { test: 'test-attitudine-gestione' } },
      { locale: 'es', params: { test: 'prueba-aptitud-gestion' } },
      { locale: 'fr', params: { test: 'test-aptitude-gestion' } },
      { locale: 'de', params: { test: 'eignungstest-management' } },
      { locale: 'pt', params: { test: 'teste-aptidao-gestao' } },
      { locale: 'en', params: { test: 'communication-style-quiz' } },
      { locale: 'it', params: { test: 'quiz-stile-comunicazione' } },
      { locale: 'es', params: { test: 'cuestionario-estilo-comunicacion' } },
      { locale: 'fr', params: { test: 'quiz-style-communication' } },
      { locale: 'de', params: { test: 'kommunikationsstil-quiz' } },
      { locale: 'pt', params: { test: 'questionario-estilo-comunicaçao' } },
    ],
    fallback: false,
  }
}

export async function getStaticProps({ locale, locales, params }) {
  /*res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )*/

  const { test } = params
  const res1 = await fetch(process.env.NEXT_PUBLIC_VENUSAUR, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      operationName: 'GetBlogsApproved4',
      query:
        'query GetBlogsApproved4($language: String){getBlogsApproved4(language: $language){id rawTitle color title article category cover resume author { firstname lastname } createdAt}}',
      variables: { language: locale },
    }),
  })

  const data = await res1.json()
  const blogs = data.data.getBlogsApproved4

  let content
  try {
    const filePath = path.join(process.cwd(), 'public', 'content', locale, 'tests.json')

    // Read the file
    const jsonData = await fs.readFile(filePath, 'utf8')
    content = JSON.parse(jsonData)
  } catch (error) {
    console.error('error', error)
  }
  if (!content || !content.tests || !content.tests[test] || !content.tests[test].faqs)
    return { notFound: true }
  return {
    props: {
      content,
      blogs,
      locale,
      locales,
      test,
      testContent: content.tests[test],
    },
  }
}

export default function Tests({ content, blogs, locale, locales, test, testContent }) {
  const [promotion, setPromotion] = useState(false)
  const size = useWindowSize()

  const onMouseOut = () => {
    const goon = localStorage.getItem('promotion')
    if (!goon) setPromotion(true)
    document.body.removeEventListener('mouseleave', onMouseOut)
  }

  useEffect(() => {
    setTimeout(function () {
      document.body.addEventListener('mouseleave', onMouseOut)
    }, 3000)
  }, [])

  const [isEnable, setIsEnable] = useState(false)
  const listfaqs = testContent?.faqs?.content?.map((f, i) => {
    return { question: f.question, answer: f.answer }
  })
  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-166939348-2"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'UA-166939348-2');
        `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NRW96HD');
        `}
      </Script>
      <Script id="hotjar" strategy="afterInteractive">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2080824,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      <OrganizationSchema />
      <WebPageSchema
        name={`${testContent.head.title}`}
        description={`${testContent.head.description}`}
      />
      <BreadcrumbListSchema
        items={[
          {
            name: 'Home',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}`,
          },
          {
            name: 'Tests',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}tests`,
          },
          {
            name: testContent.name,
            url: `https://edworking.com${locale !== 'en' ? `/${locale}` : ''}${asPathMap(
              `/tests/${test}`,
              locale
            )}`,
          },
        ]}
      />
      <FAQSchema faqs={listfaqs} />
      <Head>
        <title>{testContent.head.title}</title>
        <meta itemProp="name" content={testContent.head.title} />
        <meta itemProp="description" content={testContent.head.description} />
        <meta name="description" content={testContent.head.description} />
        <link rel="shortcut icon" href="/images/favicon.ico" />
        {locales.map((locale1, index) => (
          <link
            key={index}
            rel="alternate"
            hrefLang={locale1}
            href={`https://edworking.com${locale1 !== 'en' ? `/${locale1}` : ''}${asPathMap(
              `/tests/${test}`,
              locale1
            )}`}
          />
        ))}
        <link
          rel="alternate"
          href={`https://edworking.com/tests/${test}`}
          hrefLang="x-default"
        />
        <link
          rel="canonical"
          href={`https://edworking.com${locale !== 'en' ? `/${locale}` : ''}${asPathMap(
            `/tests/${test}`,
            locale
          )}`}
          key="canonical"
        />
      </Head>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRW96HD" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <EdworkingPromotion promotion={promotion} content={content.promotion} />
      <Offer content={content.lifetime} />
      {/*<TopBanner content={content.topbanner} />*/}
      <Header content={content.header} topbanner={true} />
      <Information
        content={testContent.head.questions}
        head={testContent.head}
        setIsEnable={setIsEnable}
      />
      {isEnable && (
        <Test
          size={size}
          content={testContent.test}
          head={testContent.head}
          explore={testContent.explore}
          setIsEnable={setIsEnable}
        />
      )}
      <FaqsGeneral content={testContent.faqs.content} head={testContent.faqs.head} />
      <SimilarArticles similar={blogs} title={'Popular Articles'} />
      <TryEdworking content={content.endbanner} />
      <Footer content={content.footer} />
      <div id="livenoti" className="livenoti"></div>
    </>
  )
}

const Information = ({ content, head, setIsEnable }) => {
  return (
    <section className="aptitude-test" id="features">
      <h1>{head.title}</h1>
      <div className="description">{head.description}</div>
      <Banner head={head} setIsEnable={setIsEnable} />
      {content.map((c, i) => (
        <div className={`plane-wrapper`} key={i}>
          <div className="plane-title">
            <p className="title">{c.question}</p>
            <p className="description">{c.answer}</p>
          </div>
          <div className="plane-inner">
            <div className={`plane`}>
              <Image
                width={460}
                height={490}
                className="img"
                style={{ borderRadius: 15, height: 'auto' }}
                src={c.image}
                alt=""
              />
            </div>
          </div>
        </div>
      ))}
    </section>
  )
}

const Banner = ({ head, setIsEnable }) => {
  return (
    <section className="banner sticky">
      <div className="text">
        <div className="subheadline">{head.banner}</div>
      </div>
      <div className="blueButton" onClick={() => setIsEnable(true)}>
        {head.button}
      </div>
    </section>
  )
}

const Status = {
  INITIAL: 0,
  LOADING: 1,
  TEST: 2,
  RESULTS: 3,
  EXPLORE: 4,
}

const Test = ({ content, head, isEnable, explore, setIsEnable, size }) => {
  const [status, setStatus] = useState(Status.INITIAL)
  const [answers, setAnswers] = useState([])
  const [result, setResult] = useState([])

  const [average, setAverage] = useState(null)
  const [scores, setScores] = useState([])
  const [info, setInfo] = useState([])

  const handleAnswer = (answer) => {
    setResult((prevResult) =>
      prevResult.concat(content.questions[answers.length].solution === answer)
    )
    setAnswers((prevAnswers) => prevAnswers.concat(answer))
    if (answers.length >= content.questions.length - 1) handleFinish()
  }

  const handleStart = () => {
    setAnswers([])
    setResult([])
    setStatus(Status.TEST)
  }
  /*
  const onMouseLeave = () => {
    setStatus(Status.EXPLORE)
  }

  useEffect(() => {
    if (status === Status.RESULTS) {
      document.body.addEventListener("mouseleave", onMouseLeave)
    }
    return () => {
      document.body.removeEventListener("mouseleave", onMouseLeave)
    }
  }, [status])
  */

  function handleFinish() {
    setStatus(Status.LOADING)
    setTimeout(() => {
      setStatus(Status.RESULTS)
    }, 2000)
  }

  const summary =
    average === 1
      ? content.summary[0]
      : average === 2
        ? content.summary[1]
        : average === 3
          ? content.summary[2]
          : average === 4
            ? content.summary[3]
            : average === 5
              ? content.summary[4]
              : null
  const phone = size.width <= 600

  return (
    <section className={`edpromotion${status !== Status.EXPLORE ? ' test' : ' offer'}`}>
      <div
        className={`modal${
          status === Status.RESULTS ? ' results' : size.width <= 350 ? ' phone' : ''
        }`}
        style={{
          fontSize: size.width <= 800 ? 15 : 18,
          padding: size.width <= 800 ? 40 : 70,
        }}
      >
        {status === Status.RESULTS ? (
          <div className="results">
            <div
              className="main"
              style={{
                flexDirection: phone ? 'column' : 'row',
                marginLeft: -20,
                marginRight: -20,
              }}
            >
              <div
                className="column left"
                style={{
                  width: phone ? '100%' : '45%',
                  marginTop: size.width <= 550 ? -50 : 0,
                }}
              >
                <div
                  className="chart"
                  style={{
                    width: size.width <= 750 ? 300 : 400,
                    height: size.width <= 750 ? 200 : 300,
                  }}
                >
                  <ResultsChart
                    data={result}
                    content={content}
                    setAverage={setAverage}
                    setScores={setScores}
                    setInfo={setInfo}
                  />
                </div>
              </div>

              <div
                className="column right"
                style={{
                  width: phone ? '100%' : '55%',
                  marginTop: phone ? -170 : 0,
                  height: phone ? 250 : 400,
                  maxHeight: phone ? 200 : 'none',
                  marginBottom: phone ? 60 : 30,
                }}
              >
                <div className="block">{summary?.emoji + ' ' + summary?.title}</div>
                <div className="summary">{summary?.text}</div>
                <div className="full-result">{content.fullresult}</div>
                {!phone &&
                  info?.map((d, i) => (
                    <div key={i} className="faq">
                      <input id={`faq-${i}`} type="checkbox" />
                      <label className="label" htmlFor={`faq-${i}`}>
                        <div className="faq-heading test">
                          {content.results[i].block}&nbsp;&nbsp;
                          {content.sections[i]}
                        </div>
                        <div className="faq-arrow"></div>
                        <p className="faq-text">{d?.description}</p>
                        <p className="faq-text">{d?.recommendation.subtitle}</p>
                        <ul>
                          <p className="faq-text">
                            {d?.recommendation.text.split('\n').map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </p>
                        </ul>
                      </label>
                    </div>
                  ))}
              </div>
            </div>

            <div
              className="blueButton"
              style={{ fontSize: phone ? 15 : 18, marginTop: phone ? -40 : 40 }}
              onClick={() => setStatus(Status.INITIAL)}
            >
              {content.button}
            </div>

            <div
              className="scores"
              style={{
                display: size.width <= 400 ? 'none' : 'unset',
                width: phone ? '100%' : '50%',
                marginTop: phone ? 0 : 5,
              }}
            >
              {content.scores}
            </div>
            <table className="scores" style={{ width: phone ? '100%' : '50%' }}>
              <thead>
                <tr>
                  {Array.from({ length: 10 }).map((_, number) => (
                    <th key={number}>{number + 1}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {new Array(10).fill(null).map((_, index) => {
                    const score = scores.length > index ? scores[index] : '-'
                    return (
                      <td key={index}>
                        {score === 1
                          ? '😵'
                          : score === 2
                            ? '🤔'
                            : score === 3
                              ? '🙂'
                              : score === 4
                                ? '😃'
                                : score === 5
                                  ? '😎'
                                  : '-'}
                      </td>
                    )
                  })}
                </tr>
              </tbody>
            </table>
            {!phone && (
              <div className={`improve${phone ? ' phone' : ''}`}>
                <p>
                  {content.improve}&nbsp;
                  <a href={content.link1} target="_blank" rel="noreferrer">
                    {content.topic1}
                  </a>
                  &nbsp;{content.and}&nbsp;
                  <a href={content.link2} target="_blank" rel="noreferrer">
                    {content.topic2}
                  </a>
                  &nbsp;{content.blogs}
                </p>
              </div>
            )}

            <div className="close" onClick={() => setStatus(Status.EXPLORE)}>
              <Image
                width={22}
                height={22}
                src="/images/ClosePromotion.png"
                alt="Close test"
              />
            </div>
          </div>
        ) : status === Status.LOADING ? (
          <div className="result">{content.loading}</div>
        ) : status === Status.TEST ? (
          <>
            <div className="block">{content.questions[answers.length]?.block}</div>
            <p
              style={{
                marginBottom:
                  size.width <= 350
                    ? 150
                    : size.width <= 440
                      ? 50
                      : size.width <= 530
                        ? 30
                        : size.width <= 1050
                          ? -10
                          : -30,
              }}
              className="question"
            >
              {answers.length + 1}. {content.questions[answers.length]?.question}
            </p>
            <div className={`ans${size.width <= 440 ? ' phone' : ''}`}>
              <div className="answers">
                <div className="select" onClick={() => handleAnswer(true)}>
                  <div />
                </div>
                <span>{content.true}</span>
              </div>
              <div className="answers">
                <div className="select" onClick={() => handleAnswer(false)}>
                  <div />
                </div>
                <span>{content.false}</span>
              </div>
            </div>
            {status !== Status.RESULTS && (
              <div className="close" onClick={() => setIsEnable(false)}>
                <Image
                  width={22}
                  height={22}
                  src="/images/ClosePromotion.png"
                  alt="Close test"
                />
              </div>
            )}
          </>
        ) : status === Status.INITIAL ? (
          <div className="instructions">
            <div className="title">{content.introduction.title}</div>
            <p className="text">{content.introduction.text}</p>
            <div
              className="blueButton"
              style={{ fontSize: phone ? 15 : 18, marginTop: phone ? 20 : 40 }}
              onClick={handleStart}
            >
              {head.button}
            </div>
            {status !== Status.RESULTS && (
              <div className="close" onClick={() => setIsEnable(false)}>
                <Image
                  width={22}
                  height={22}
                  src="/images/ClosePromotion.png"
                  alt="Close test"
                />
              </div>
            )}
          </div>
        ) : (
          status === Status.EXPLORE && (
            <div className="banner offer test">
              <div className="text">
                <div className="headline">{explore.title}</div>
                <div className="top">
                  <div className="subheadline">{explore.description1}</div>
                  <div className="column">
                    <Image
                      width="32"
                      height="20"
                      className="image"
                      src="/images/Logo.svg"
                      alt=""
                    />
                  </div>
                </div>
                <div className="bottom">
                  <a className="blueButton" href="https://app.edworking.com/signup/user/">
                    {explore.cta1}
                  </a>
                </div>
                <div className="subheadline2">{explore.description2}</div>
                <div className="bottom">
                  <a className="whiteButton" href="https://edworking.com/solutions/startups/">
                    {explore.cta2}
                  </a>
                </div>
              </div>

              {status !== Status.RESULTS && (
                <div className="close" onClick={() => setIsEnable(false)}>
                  <Image
                    width={22}
                    height={22}
                    src="/images/ClosePromotion.png"
                    alt="Close test"
                  />
                </div>
              )}
            </div>
          )
        )}
      </div>
    </section>
  )
}

export const FaqsGeneral = ({ content, head }) => {
  return (
    <section className="freques">
      <div className="title">{head.title}</div>
      {content?.map((c, i) => (
        <div className="faq" key={i}>
          <input id={`faq-${i}`} type="checkbox" />
          <label htmlFor={`faq-${i}`}>
            <p className="faq-heading">{c.question}</p>
            <div className="faq-arrow"></div>
            <p className="faq-text">{c.answer}</p>
          </label>
        </div>
      ))}
    </section>
  )
}
